import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../configApi";
const initialState = {
  isLoading: false,
  isNotify: false,
  isError: false,
  msg: "",
  dataMenu: [],
  dataMenuWithType: [],
  dataMenuForAdmin: [],
  menuValueSelect: [],
  isOpenAddTab: false,
  isOpenModalEditTab: false,
  isOpenModalRigthClick: false,
  dataDisplay: [],
  dataEdit: [],
  refetch: false,
};
const ConfigMenuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setValueSelect: (state, action) => {
      state.menuValueSelect = action.payload;
    },
    setOpenModalRightCick: (state, action) => {
      state.isOpenModalRigthClick = action.payload;
    },
    setOpenAddTab: (state, action) => {
      state.isOpenAddTab = action.payload;
    },
    resetNotifyMenu: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.isError = false;
    },
    setOpenModalEditTabMenu: (state, action) => {
      state.isOpenModalEditTab = action.payload.isOpen;
      state.dataEdit = action.payload.data;
    },
  },
  extraReducers: (builder) => {
    builder
      //get all menu
      .addCase(getALLMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getALLMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataMenu = action.payload;
        state.refetch = false;
      })
      .addCase(getALLMenu.rejected, (state) => {
        state.isLoading = true;
      })
      //get menu with type
      .addCase(getMenuWithType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMenuWithType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataMenuWithType = action.payload;
      })
      .addCase(getMenuWithType.rejected, (state, action) => {
        state.isLoading = true;
      })
      //get menu for Admin
      .addCase(getMenuForAdmin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMenuForAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataMenuForAdmin = action.payload;
      })
      .addCase(getMenuForAdmin.rejected, (state, action) => {
        state.isLoading = true;
      })
      //save config
      .addCase(saveConfig.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isNotify = true;
        state.msg = "Cấu hình menu thành công";
      })
      .addCase(saveConfig.rejected, (state, action) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      //save config admin
      .addCase(saveConfigAdmin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveConfigAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isNotify = true;
        state.msg = "Cấu hình menu thành công";
      })
      .addCase(saveConfigAdmin.rejected, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //edit config admin
      .addCase(editTabMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editTabMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.msg = "Chỉnh sửa tab menu thành công";
          state.isOpenModalEditTab = false;
          state.refetch = true;
        }
      })
      .addCase(editTabMenu.rejected, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //add config admin
      .addCase(addTabMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addTabMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.msg = "Thêm tab menu thành công";
          state.isOpenAddTab = false;
          state.refetch = true;
          state.isError = false;
        } else {
          state.isError = true;

          state.msg = action.payload.message;
        }
      })
      .addCase(addTabMenu.rejected, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //delete config admin
      .addCase(deleteTabMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteTabMenu.fulfilled, (state, action) => {
        if (action.payload.status) {
          state.isLoading = false;
          state.isNotify = true;
          state.refetch = true;
          state.msg = "Xóa tab menu thành công";
        }
      })
      .addCase(deleteTabMenu.rejected, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // get all display
      .addCase(getAllDisplay.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllDisplay.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataDisplay = action.payload;
      })
      .addCase(getAllDisplay.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});
export default ConfigMenuSlice;
export const {
  setValueSelect,
  setOpenAddTab,
  resetNotifyMenu,
  setOpenModalRightCick,
  setOpenModalEditTabMenu,
} = ConfigMenuSlice.actions;
//get list menu
export const getALLMenu = createAsyncThunk("menu/getMenu", async (type) => {
  try {
    const res = await instance.get(`menu/getAllItem?type=${type}`);
    const result = res.data;
    return result.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
});
//get list menu for edit
export const getMenuWithType = createAsyncThunk(
  "menu/getMenuWithType",
  async (type) => {
    try {
      const res = await instance.get(`menu/menuConfig?type=${type}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//get list menu foradmin
export const getMenuForAdmin = createAsyncThunk(
  "menu/getMenuForAdmin",
  async (type) => {
    try {
      const res = await instance.get(`menu/getMenu?type=1`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

//save Config
export const saveConfig = createAsyncThunk("menu/saveConfig", async (data) => {
  try {
    const res = await instance.post(`menu/config`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = res.data;
    return result.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
});
//save Config admin
export const saveConfigAdmin = createAsyncThunk(
  "menu/saveConfigAdmin",
  async (data) => {
    try {
      const res = await instance.post(`menu/configAdmin`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//add tab
export const addTabMenu = createAsyncThunk("menu/addTabMenu", async (data) => {
  try {
    const res = await instance.post(`menu/addMenu`, data, {
      headers: {
        "Content-type": "multipart/form-date",
      },
    });
    const result = res.data;
    return result;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
});
//get select display
export const getAllDisplay = createAsyncThunk(
  "menu/getAllDisplay",
  async () => {
    try {
      const res = await instance.get(`component/getAll`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//delete tab
export const deleteTabMenu = createAsyncThunk(
  "menu/deleteTabMenu",
  async (data) => {
    try {
      const res = await instance.delete(
        `/menu/deleteMenu?type=${data.type}&id=${data.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//edit tab
export const editTabMenu = createAsyncThunk(
  "menu/editTabMenu",
  async (data) => {
    try {
      const res = await instance.post(`/menu/updateMenu`, data, {
        headers: {
          "Content-type": "multipart/form-date",
        },
      });
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
